import React from 'react';
import { Link } from 'react-router-dom';
import HelpApiLayout from '../../components/layout/HelpApiLayout';
import ApiSidebar from '../../components/layout/ApiSidebar';
import { PUBLIC_ROUTES } from '../../constants/routes';
import { getApiDocsRoute } from '../../utils/navigation';
import './ApiDocs.css';

/**
 * API Documentation Main Page
 * Landing page for API documentation with overview and quick links
 */
const ApiDocs = () => {
  return (
    <HelpApiLayout type="api" sidebar={<ApiSidebar />}>
      <div className="api-docs">
        <div className="api-docs-container">
          <header className="lp-section-header">
            <h1 className="lp-section-title">API Documentation</h1>
            <p className="lp-section-subtitle">
              Complete reference for integrating with the WeSplit API
            </p>
          </header>

          <section className="api-docs-quick-links">
            <h2 className="lp-section-card-label-h3">Quick Start</h2>
            <div className="api-docs-cards">
              <Link to={getApiDocsRoute(PUBLIC_ROUTES.API_DOCS_OVERVIEW)} className="api-docs-card">
                <h3>Overview</h3>
                <p>Get started with the WeSplit API</p>
              </Link>
              <Link to={getApiDocsRoute(PUBLIC_ROUTES.API_DOCS_AUTH)} className="api-docs-card">
                <h3>Authentication</h3>
                <p>Learn how to authenticate your requests</p>
              </Link>
              <Link to={getApiDocsRoute(PUBLIC_ROUTES.API_DOCS_SPLITS)} className="api-docs-card">
                <h3>Splits</h3>
                <p>Manage splits and expenses</p>
              </Link>
              <Link to={getApiDocsRoute(PUBLIC_ROUTES.API_DOCS_TRANSACTIONS)} className="api-docs-card">
                <h3>Transactions</h3>
                <p>Coming Soon - Transaction endpoints</p>
              </Link>
              <Link to={getApiDocsRoute(PUBLIC_ROUTES.API_DOCS_WALLETS)} className="api-docs-card">
                <h3>Wallets</h3>
                <p>Coming Soon - Wallet management endpoints</p>
              </Link>
              <Link to={getApiDocsRoute(PUBLIC_ROUTES.API_DOCS_ERRORS)} className="api-docs-card">
                <h3>Error Codes</h3>
                <p>Reference for API error responses</p>
              </Link>
            </div>
          </section>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default ApiDocs;
